import { axiosInstance } from "../utils/axios";
import { getAuthHeader } from "../utils/authTools";

export const resetPassword = async (request) => {
    let response = await axiosInstance.patch(
        `/user/updatepassword`,
        request,
        getAuthHeader()
    );
    return response.data;
};

export const getAllUsers = async (request) => {
    let response = await axiosInstance.get(
        `/user/all?${request}`,
        getAuthHeader()
    );
    return response.data;
};

export const saveAiChoice = async (request) => {
    let response = await axiosInstance.post(
        `/user/updateUserAI`,
        request,
        getAuthHeader()
    );
    return response.data;
};

export const bulkUpdateAI = async (request) => {
    let response = await axiosInstance.post(
        `/user/bulk-update-ai`,
        request,
        getAuthHeader()
    );
    return response.data;
};

export const getUsersForBulkUpdate = async () => {
    let response = await axiosInstance.get(
        `/user/users-for-bulk-update`,
        getAuthHeader()
    );
    return response.data;
};

export const getAllUsers2 = async () => {
    let response = await axiosInstance.get(
        `/user/allUser`,
        getAuthHeader()
    );
    return response.data;
};

export const updatedUserStatus = async (request) => {
    let response = await axiosInstance.patch(
        `/user/update-user-status`,
        request,
        getAuthHeader()
    );
    return response.data;
};

export const changeAdminStatus = async (request) => {
    let response = await axiosInstance.patch(
        `/user/change-admin-status`,
        request,
        getAuthHeader()
    );
    return response.data;
};

export const updateUser = async (request) => {
    let response = await axiosInstance.patch(
        `/user`,
        request,
        getAuthHeader()
    );
    return response.data;
};

export const deleteUser = async (request) => {
    let response = await axiosInstance.delete(
        `/user/${request.id}`,
        getAuthHeader()
    );
    return response.data;
};

export const resetOAuth = async (id) => {
    let response = await axiosInstance.put(
        `/user/resetOAuth/${id}`, {},
        getAuthHeader()
    );
    return response.data;
};